module.exports = __webpack_public_path__ + "static/img/302_TO8_2005_og.edcb054.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/302_TO8_2005_og.jpg
// module id = quQr
// module chunks = 0